import { render } from "./ManageThemeColour.vue?vue&type=template&id=b24b6278&lang=pug"
import script from "./ManageThemeColour.vue?vue&type=script&lang=js"
export * from "./ManageThemeColour.vue?vue&type=script&lang=js"

import "./ManageThemeColour.vue?vue&type=style&index=0&id=b24b6278&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__